#import "../fragments/accounts-for-lead-fragment.graphql"
#import "../fragments/contacts-for-lead-fragment.graphql"

mutation RemoveContactForLead($input: LeadRemoveContactInput!) {
    leadRemoveContact(input: $input) {
        lead {
            ...AccountsForLeadFragment
            ...ContactsForLeadFragment
        }
    }
}
